
import { defineComponent, nextTick } from 'vue';
import Vue from 'vue';
import VueObserveVisibility from 'vue-observe-visibility';
import PrzAuthorship from '@/components/Social/Dialogs/Parts/Authorship/Component.vue';
import PrzThread from '@/components/Social/Dialogs/Parts/Thread/Component.vue';
import PrzNewComment from '@/components/Social/Dialogs/Parts/NewComment/Component.vue';
import PrzLike from '@/components/Muffin/Like.vue';
import { SocialDialog, SocialThreadType } from '@/models/Social/social-dialog';

Vue.use(VueObserveVisibility);

export default defineComponent({
    components:{
        PrzAuthorship,
        PrzThread,
        PrzLike,
        PrzNewComment
    },
    props:{
        dialog: {
            type: SocialDialog,
            default: null
        },
        useObserver:{
            type: Boolean,
            default: true
        },
        isGuest: {
            type: Boolean,
            default: true
        },
        saveUrl: {
            type: String,
            default: undefined
        },
    },
    data(){
        return {
            collapsed: true,
            extensive: true,
            translation: false,
            showReply: false
        }
    },
    watch:{
        dialog(dialog){
            if(dialog && dialog.loading){
                return true;
            }
            nextTick(() => {
                this.calcHeight();
            });
        }
    },
    computed:{
        showNewComment(): boolean{
            return this.showReply && !this.isGuest;
        },
        likesNum(): string{
            let num: number = this.dialog?.likes?.num ?? 0;
            return `${num > 0 ? num : ''}`;
        },
        likesCount(): number|undefined{
            return this.dialog?.likes?.num ?? undefined;
        },
        likesInfo(): object|undefined{
            return this.dialog?.likes?.params() ?? undefined;
        },
        headerText(): string{
            if(this.dialog && this.dialog.thread){
                if(this.dialog.thread.type == SocialThreadType.PendingComment){
                    return this.dialog.kStrings.pendingReview ?? '';
                }
                let text: string|undefined = this.dialog.thread.type == SocialThreadType.Answer ? this.dialog.kStrings.asked : 
                    (this.dialog.thread.type == SocialThreadType.Question ? this.dialog.kStrings.asked : this.dialog.kStrings.commented);
                if(text){
                    return text;
                }
            }
            return '';
        },
        isPending(){
            return this.dialog?.thread?.type == SocialThreadType.PendingComment;
        },
    },
    methods:{
        calcHeight(){
            let elem = this.$el.querySelector('.prz-social-dialog-thread');
            if(elem && (elem instanceof HTMLElement)){
                this.extensive = elem.offsetHeight >= 370;
            }
        },
        like(data: any){
            if(this.dialog.likes && (data?.liked ?? null) !== null && data.liked != this.dialog.likes.liked){
                this.dialog.likes.num += data.liked ? +1 : -1;
                this.dialog.likes.liked = data.liked;
            }
        },
        collapse(){
            if(!this.collapsed){
                this.$emit('collapse');
            }else{
                this.$emit('expand');
            }
            this.collapsed = !this.collapsed;
        },
        cancel(){
            this.showReply = false;
            this.$emit('show-reply', false);
        },
        reply(){
            //this.$emit('reply',{postId: this.dialog.postId, parent: this.dialog.thread.id});
            this.showReply = true;
            this.$emit('show-reply', true);
        },
        async visibilityChanged(isVisible: boolean){
            if(isVisible){
                await this.dialog.getReplies();
                this.calcHeight();
            }
        }
    }
});

